<template>
  
  <!-- <div v-if="isColorfulLayoutType()" class="text-center overflow-y-hidden"> -->



  <div v-if="businessView" class="text-center overflow-y-hidden">

    <!-- <div v-if="appIsLoaded == false" class="w-full flex justify-center content-around items-center h-screen"> -->
    <div v-if="!appIsLoaded" class="w-full flex justify-center mt-64 h-screen">
      
      <div>
        <div class="w-full flex justify-center">

          <img class="w-32 h-32 mb-10" src="@/assets/images/only-logo.jpg"/>
        </div>

        <div>
          
          <label class="p-1 bg-blue-200 rounded-lg border border-black object-contain">Please wait</label>
        </div>

        <div v-if="isFirstLaunch" class="mt-10">

          <label class="p-1 bg-pink-200 rounded-lg border border-black">For the first time, this will take few seconds</label>
        </div>
       </div> 
    </div>
    <!-- <div  id="app" class="w-full bg-blue-100"> -->
    <div v-else class="w-full bg-blue-100">

    <!-- :class="{'bg-blue-100': isPinkStyle , 'my-bg-white': !isPinkStyle}"> -->

    <!--     
      <script src="https://unpkg.com/vue" type="application/javascript"></script>
      <script src="https://unpkg.com/vue-cal" type="application/javascript"></script> -->

      <!-- The core Firebase JS SDK is always required and must be listed first -->
      <!-- <script src="https://www.gstatic.com/firebasejs/7.19.1/firebase-app.js"></script> -->

      <!-- TODO: Add SDKs for Firebase products that you want to use
          https://firebase.google.com/docs/web/setup#available-libraries -->
      <!-- <script src="https://www.gstatic.com/firebasejs/7.19.1/firebase-analytics.js"></script> -->


      <!-- <script type="text/javascript" src="cordova.js"></script> -->

          <!-- <script src="static/cordova-loader.js"></script>

          <script src="https://data.jsdelivr.com/v1/package/npm/cordova-js/badge"></script>
          <script src="https://www.jsdelivr.com/package/npm/cordova-js"></script>

        <script type=”text/javascript” src="bundle/www/cordova.js"></script>

          <script src="https://data.jsdelivr.com/v1/package/npm/cordova-js/badge)](https://www.jsdelivr.com/package/npm/cordova-js"></script> -->

        <script type=”text/javascript” src="js/jquery-2.1.3.min.js"></script>
        <script type=”text/javascript” src="js/stacktrace.min.js"></script>
        <script type=”text/javascript” src="js/index.js"></script>

      <link rel="stylesheet" href="https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css">
  
      <link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">

      <!--hide bars hidebars-->
      <div class="sticky top-0 z-50" v-if="!hideBars()">
      
        <div  v-if="!isAuthenticated" class="flex flex-row justify-center items-center text-xl lg:text-2xl text-center w-full"
              :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">
            <!-- <label class=" mt-10 h-20 w-full lg:w-1/2">{{ this.$t('menu.forClassesLogin')}} </label> -->
        </div>

        <!-- <div  v-if="isAuthenticated" class=" w-full" > -->
          
        <div  v-else class="sticky top-0 z-50 w-full" >
          
          <div v-if="!hideTopBar">

            <div v-if="userType == 3" class="flex flex-row w-full justify-between items-center bg-yellow-100 me-2">

              <div v-if="$route.name !='home'" @click="goBack" class="ms-2 flex bg-pink-600 rounded-t">

                <div  class="cursor-pointer hover:bg-pink-500 h-8 w-8 lg:h-16 lg:w-16">

                  <img v-if="$i18n.locale == 'ar'" src="@/assets/images/back-icon.svg" 
                  style="-webkit-transform: scaleX(-1);transform: scaleX(-1);"
                  class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <img v-else   src="@/assets/images/back-icon.svg" 
                  class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                </div>
              </div>

              <!-- <div class=" pl-2 lg:ms-2 lg:pt-2 lg:h-10 flex bg-pink-300 w-64 rounded-full text-xs lg:text-md">
                <label v-if="businessView">{{$t('menu.switchToClient')}}</label>
                <label v-else>{{$t('menu.switchToBusiness')}}</label>

                      <toggle-button :width="90" v-model="businessView" @change="setBusinessView"
                      :labels="{checked: `${$t('menu.businessPlaceholder')}`, unchecked: ''}"
                      :color="{checked: '#48BB78', unchecked: '#4299E1', disabled: '#CCCCCC'}"/>
              </div> -->

              <div class="flex justify-center items-center w-full"  v-if="showLoader">
                
                  <ring-loader ></ring-loader> 
              </div>

              <div v-else @click="reloadApp" class="h-8 w-8 lg:h-16 lg:w-16 me-6">

                <img src="@/assets/images/iconfinder_refresh.svg" class="rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>
              </div>
            </div>


            <div v-else class="flex flex-row w-full justify-between items-center bg-yellow-100 me-2">

              <div v-if="$route.name !='home'" @click="goBack" class="ms-4 flex rounded-t">

                <div  class="cursor-pointer hover:bg-pink-500 h-8 w-8 lg:h-16 lg:w-16">

                  <img v-if="$i18n.locale == 'ar'" src="@/assets/images/back-icon.svg" 
                  style="-webkit-transform: scaleX(-1);transform: scaleX(-1);"
                  class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>

                  <img v-else   src="@/assets/images/back-icon.svg" 
                  class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>


                </div>
              </div>

              <div class="flex justify-center items-center w-full"  v-if="showLoader">
                
                  <ring-loader class="rounded-full" ></ring-loader> 
              </div>

              <div v-else @click="reloadApp" class="">

                <div v-if="$route.name !='home'">

                  <img src="@/assets/images/iconfinder_refresh.svg" class="me-6 rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                </div>

                <div v-else>

                  <img src="@/assets/images/iconfinder_refresh.svg" class="ms-64 self-end rounded-full p-1 lg:p-3 object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                </div>
              </div>
            </div>
          </div>
          
          <div v-if="layoutType == 0" id="nav" class="flex justify-between lg:justify-around text-md lg:text-lg w-full"
            :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">

            <div>
                <router-link to="/home" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.home')}}</router-link>
              </div>
              
              <div v-if="businessView">

                <router-link v-if="userType != 3" to="/profile" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.profile')}}</router-link>
                
              </div>
              
              <div v-else>

                <router-link to="/profile" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.profile')}}</router-link>
              </div>

          <div v-if="businessView">

                <router-link to="/brand" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.myBrand')}}</router-link>
              </div >

              <div v-else>
                
                <router-link to="/activities" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.inbox')}}</router-link>
              </div>

              <div v-if="businessView" class="group" 
              @mouseover="brandIsHovered(true)"
              @mouseleave="brandIsHovered(false)" ref="menuDropdownRef">

                <div>

                  <a 
                  class=" text-white text-center hover:bg-purple-300 active:bg-pink-400">
                      <!-- <svg class="h-6 w-6 fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.783 12c0-1.049.646-1.875 1.617-2.443a8.932 8.932 0 0 0-.692-1.672c-1.089.285-1.97-.141-2.711-.883-.741-.74-.968-1.621-.683-2.711a8.732 8.732 0 0 0-1.672-.691c-.568.97-1.595 1.615-2.642 1.615-1.048 0-2.074-.645-2.643-1.615-.58.172-1.14.403-1.671.691.285 1.09.059 1.971-.684 2.711-.74.742-1.621 1.168-2.711.883A8.797 8.797 0 0 0 3.6 9.557c.97.568 1.615 1.394 1.615 2.443 0 1.047-.645 2.074-1.615 2.643.173.58.404 1.14.691 1.672 1.09-.285 1.971-.059 2.711.682.741.742.969 1.623.684 2.711.532.288 1.092.52 1.672.693.568-.973 1.595-1.617 2.643-1.617 1.047 0 2.074.645 2.643 1.617a8.963 8.963 0 0 0 1.672-.693c-.285-1.088-.059-1.969.683-2.711.741-.74 1.622-1.166 2.711-.883.287-.532.52-1.092.692-1.672-.973-.569-1.619-1.395-1.619-2.442zM12 15.652a3.653 3.653 0 1 1 0-7.306 3.653 3.653 0 0 1 0 7.306z" fill-rule="nonzero"></path></svg> -->
                      {{ this.$t('menu.business')}} <label><strong class="w-8 h-16 bg-blue-400 rounded-full text-white">&#8250;</strong></label>
                  </a>
                </div>

                <div v-if="brandHover" v-click-outside="cancelBrandHover" class="items-center absolute border border-t-0 rounded-b-lg
                p-1 bg-white w-24 lg:w-auto me-10 lg:pr-0 z-50">

                  <!-- <div v-bind:class="{'hidden': !brandHover, 'block': brandHover}"
                      class="bg-white text-base  float-left py-2 list-none text-left rounded shadow-lg mb-1" ref="DropdownRef"> -->

                    <!-- <a href="/brand" class="px-4 py-2 block text-black hover:bg-indigo-300">{{$t('menu.manageBrands')}}</a>
                    <hr class="border-t mx-2 border-grey-light"> -->

                    <!-- <a href="/business" class="px-4 py-2 block text-black hover:bg-indigo-300">{{$t('menu.manageBusiness')}}</a>
                    <hr class="border-t mx-2 border-grey-light">
                    <a href="/delegation" class="px-4 py-2 block text-black hover:bg-indigo-300">{{$t('menu.delegateUsers')}}</a> -->

                  <router-link to="/business" class="px-4 py-2 block text-black hover:bg-indigo-300">
                <span @click="cancelBrandHover">{{ this.$t('menu.manageBusiness')}}</span> </router-link>
                                  
                  <hr class="border-t mx-2 border-grey-light">

                <router-link to="/delegation" class="px-4 py-2 block text-black hover:bg-indigo-300">
                  <span @click="cancelBrandHover">{{ this.$t('menu.delegateUsers')}}</span></router-link>
                </div>
              </div>
            
              <div v-else>

                  <router-link to="/bookings" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.tickets')}}</router-link>
              </div>
          </div>

          <div v-if="layoutType == 1" id="nav" class="flex justify-between lg:justify-around text-md lg:text-lg w-full"
            :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">

            <!-- <div v-if="businessView" class="group" 
              @mouseover="brandHover = true
              @mouseleave="brandHover = false"> -->

              <div v-if="businessView">

                  <router-link to="/classes" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.classes')}}</router-link>
              </div >

                <div v-else>
                
                <router-link to="/sessions" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.sessions')}}</router-link>
              </div>

              <div v-if="businessView">

                <router-link to="/businessMemberships" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.memberships')}}</router-link>
              </div >

              <div v-else>
                
                <router-link to="/clientSubscriptions" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.memberships')}}</router-link>
              </div>
              

              <div v-if="businessView">

                  <!-- <router-link to="/slots" class="w-1/6 py-4 my-router-link " -->
                  <router-link to="/fitnessDashboard" class="w-1/6 py-4 my-router-link "

                  :class="{' my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.dashBoard')}}</router-link>
              </div>

              <div v-else>

                <router-link to="/PnadiSearch" class="w-1/6 py-4 my-router-link "
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.search')}}</router-link>
              </div>
              
              <!-- <div v-if="businessView && userType != 3">

                  <router-link to="/PnadiSearch" class="w-1/6 py-4 my-router-link "
                  :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.search')}}</router-link>
              </div> -->
          </div>

          <div v-if="layoutType == 2" id="nav" class="flex justify-between lg:justify-around text-md lg:text-lg w-full"
            :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">
          <!-- :class="{'my-light-app-div': isPinkStyle , 'my-main-app-div': !isPinkStyle}"> -->

            <div v-if="businessView">

                  <router-link to="/pitch" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.pitch')}}</router-link>
              </div >

            <div v-else>

              <router-link to="/player" class="w-1/6 py-4 my-router-link"
              :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
              {{ this.$t('menu.playerProfile')}}</router-link>
            </div>

            <div v-if="businessView">

                  <router-link to="/Pitchdashboard" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.pitchDashboard')}}</router-link>
            </div >

              <div v-else>

                <router-link to="/bookingPitches" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.bookingPitches')}}</router-link>
              </div>

              <div v-if="!businessView">

                <router-link to="/playersGroups" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.playersGroups')}}</router-link>
              </div>
          </div>

          <div v-if="layoutType == 3" id="nav" class="flex justify-between lg:justify-around text-md lg:text-lg w-full"
            :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">
          <!-- :class="{'my-light-app-div': isPinkStyle , 'my-main-app-div': !isPinkStyle}"> -->

            <div v-if="businessView">

                  <router-link to="/businessMemberships" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.memberships')}}</router-link>
              </div >

            <!-- <div v-else>

              <router-link to="/player" class="w-1/6 py-4 my-router-link"
              :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
              {{ this.$t('menu.playerProfile')}}</router-link>
            </div>

            <div v-if="businessView">

                  <router-link to="/Pitchdashboard" class="w-1/6 py-4 my-router-link"
                  :class="{'my-main-router-link': isPinkStyle , ' my-light-router-link': !isPinkStyle}">
                  {{ this.$t('menu.pitchDashboard')}}</router-link>
            </div >

              <div v-else>

                <router-link to="/bookingPitches" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.bookingPitches')}}</router-link>
              </div>

              <div v-if="!businessView">

                <router-link to="/playersGroups" class="w-1/6 py-4 my-router-link"
                :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
                {{ this.$t('menu.playersGroups')}}</router-link>
              </div> -->
          </div>
        </div> 
      </div>
        <!--end of hide bars hidebars -->
        
        <!--v-else of hide bars hidebars -->
      <div v-else id="nav" class="flex justify-between lg:justify-around text-md lg:text-lg w-full"
          :class="{'my-main-app-div': isPinkStyle , 'my-light-app-div': !isPinkStyle}">

          <div>
              <router-link to="/home" class="w-1/6 py-4 my-router-link"
              :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
              {{ this.$t('menu.home')}}</router-link>
            </div>
            
            <div v-if="businessView">

              <router-link v-if="userType != 3" to="/profile" class="w-1/6 py-4 my-router-link"
              :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
              {{ this.$t('menu.profile')}}</router-link>
              
            </div>
            
            <div v-else>

              <router-link to="/profile" class="w-1/6 py-4 my-router-link"
              :class="{'my-main-router-link': isPinkStyle , 'my-light-router-link': !isPinkStyle}">
              {{ this.$t('menu.profile')}}</router-link>
            </div>

      </div>
        <!--end of v-else for hide bars hidebars -->


      <!-- 7- switch for  second slots -->
      <div class="">
      
        <div v-if="$store.state.loadingPage" class="myCenter">
    
            <ring-loader ></ring-loader>
        </div>  

        <router-view v-else/>
      </div>




      <!-- iOS Submission-->

      <!-- <div v-if="isIos() && isAuthenticated">

        <second-slots />
      </div>

    <div v-else class="">

        <router-view/>
      </div> -->

      <!-- <div>

          <button class="add-button">Add to home screen</button>

      </div> -->

      <!-- <div v-if="$route.name !='home' && $route.name != 'main'"> -->


      <!-- <div v-if="$layoutType != 0 && isAuthenticated">

        <footer>

        <section id="bottom-navigation" class="block fixed inset-x-0 bottom-0 z-10 bg-blue-400 text-white shadow ">
            
            <div id="tabs" class="flex justify-around flex-wrap">

                <a  @click="switchLayout(0)"
                  class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent text-gray-800">
                  
                    <img src="@/assets/images/only-logo.jpg" class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                </a>              

                <a @click="switchLayout(1)"
                  class="bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap text-gray-800">
                  
                      <img src="@/assets/images/fitness-icon.svg" class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                  </a>

                  <a @click="switchLayout(2)"  
                  class="hover:bg-pink-600 text-sm py-2 px-4 font-normal block whitespace-no-wrap bg-transparent  text-gray-800">
                  
                    <img src="@/assets/images/pitch-icon.svg" class="rounded-full p-1 lg:p-3 bg-white object-contain h-8 w-8 lg:h-16 lg:w-16"/>
                  </a>
            </div>
        </section>
        
      </footer>

      </div>

      <div v-else>

        <my-footer class="h-10 lg:h-20" :name_1="'Reload/Refresh'" :name_2="'Instagram'" :name_3="'Reset/App'" :action_1="reLoadApp"
        :action_2="switchLayout" :action_3="resetApp"></my-footer>
      </div> -->
    
      <!-- to do -->
      <!-- 8- switch hide bars -->


      <div v-if="isIos()" class="h-32">
      </div>
      
      <div v-if="!hideBars()">
        <!-- <div> -->

        <my-footer class="sticky bottom-0 h-10 lg:h-20 z-50" :name_1="'Reload/Refresh'" :name_2="'Instagram'" :name_3="'Reset/App'" :action_1="reloadApp"
        :action_2="switchLayout" :action_3="resetApp" :isAuthenticated="isAuthenticated" :isUserBroker="isUserBroker"
        :userType="userType" :businessView="businessView" :changeBusinessView="changeBusinessView"/>
      </div>
    </div>
  </div>

  <!-- <div v-else-if="adminView">

    <app-admin/>
  </div> -->

  <div v-else>


    <app-v2 :isBusinessview="businessView"/>
  </div>
</template>

<script>

// window.actions.alertFromiOS = function alertFromiOS(){

//         alert(`in alertFromiOS`);

// };

  function myPostMessage(){

        // alert(`in myPostMessage`);
  };

  function callFakeBookingMutate(value1, value2, value3){
    
    // alert(`in callFakeBookingMutate, with ${value1}, ${value2}, ${value3}`);
    
    // console.log(`in callFakeBookingMutate, with ${value1}, ${value2}, ${value3}`);

    return;
    try{

        let result = axios({method: 'post',url: '/pnadiapi/fakeBookings/bookSession',
            data: {
            
            // key: this.storedKey,
            // userId: this.userId,
            // slotId: slot.id,
            // points: slot.points_cost,
            // dayDate: this.dayDate
            }});
    }catch(error){

        console.log(`error: ${error}`);
    }
}

import parameters from './classes/parameters'

import myQueries from './hasura/myQueries';

import myDeletes from './hasura/myDeletes';

import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js'

import { ToggleButton } from 'vue-js-toggle-button'
import Vue from 'vue';

import componentsHelpers from './classes/componentHelpers';

import LocaleSwitcher from './components/LocaleSwitcher';

import secondSlots from './views/SecondSlots';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import MyFooter from './components/MyFooter5';

import { RingLoader } from 'vue-spinners-css';

import authHttpHelper from './auth/auth-http-helper'
import { subscribe } from 'graphql';
import myThreeDeletes from './hasura/myThreeDeletes';
import myThreeInserts from './hasura/myThreeInserts';

import appV2 from './AppV2'

import otherServices from './classes/otherServices';

// import BackMixin from `vue-router-back-mixin`

const fullConfig = resolveConfig(tailwindConfig)

// const push = require('web-push');

// let vapIdKeys = push.generateVAPIDKeys();

// console.log(`vapIdKeys: ${JSON.stringify(vapIdKeys)}` );

export default {

  

  //  errorCaptured(err,vm,info) {

  // console.log(`Error Capture, Err: ${JSON.stringify(err)}`);
  // console.log(`Error Capture, vm: ${JSON.stringify(vm)}`);

  // console.log(`Error Capture, info: ${JSON.stringify(info)}`);

  // console.log(`Error Capture, $apollo: ${JSON.stringify(Vue.$apollo)}`);

  // console.log(`Error Capture, just apollo: ${JSON.stringify(Vue.apollo)}`);    
  
  // return false;
  // },

  components: {
  
  RingLoader,
  ToggleButton,
  LocaleSwitcher,
  secondSlots,
  MyFooter,
  appV2
  },

  // async beforeCreate(){
  async myBeforeCreate(){

    //  if(await this.$auth.isAuthenticated() || this.isAuthenticated){

    //     const apollo = this.$apollo;

    //     console.log(`apollo: ${apollo}`)

    //     const toasted = this.$toasted;

    //     let userResult = await this.$apollo.query({
          
    //       query: myQueries.my_user_query,
          
    //       error(error){
            
    //         this.allLoaded = false;

    //         componentsHelpers.sendError(apollo, this.$userId, 'App', ',main', 'loadAllInfo - 2' , error);
                
    //         componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            
    //         this.tokenError = JSON.stringify(error);
    //       },   
    //     });

    //     if(userResult.data.token.length > 0){
          
    //       if(userResult.data.token.user != null){

    //         this.$userId = userResult.data.user[0].id;
    //       }
    //     }
    //     else{

    //       this.$userId = 0;
    //     }

    //     // console.log(`this.$userId: ${JSON.stringify(this.$userId)}`);
    //   }
  },
  // mixins: [BackMixin],

  async created(){

    if(localStorage.hasOwnProperty('appIsLoaded')){

      // this.appIsLoaded = true;

      this.isFirstLaunch = false;
    }else{

      this.isFirstLaunch = true;
    }

     document.onreadystatechange = () => { 
       
            //  console.log(`before loaded`);
            //  console.log(`document.readyState: ${document.readyState}`)
        //To load the app only after all libraries are loaded
        if (document.readyState == "complete") { 

            this.appIsLoaded = true;
            // console.log(`in complete`);
            localStorage.setItem('appIsLoaded', this.appIsLoaded);
        } 
   }
    // console.log(`in created`);

      this.getCountry();

      let value = false;

      if(localStorage.hasOwnProperty("businessView")){

        if(!localStorage.getItem('businessView').includes('undefined')){

          value = localStorage.getItem('businessView');

          // console.log(`typeof businessView ${typeof value}`);
          // console.log(`businessView ${value}`);

          if (value === null) {
              // console.log('was null setting to false');
              value = false;
          } else {
              value = JSON.parse(value)
          }

          value = JSON.parse(value)

          this.businessView = value;

          this.switchMenu = value;
        }
      }
      
      this.businessView = value;
      // console.log(`businessView ${this.businessView}`);

    // this.getBusinessView();

    await this.checkingAuthentication();

    // this.sendMessage();

    if(this.isIos()){

      // alert(`user agent: ${navigator.userAgent}`);

      // alert(`isAuthenticated: ${this.isAuthenticated}`);

      // console.log(`isAuthenticated: ${this.isAuthenticated}`);

      this.hideTopBar = true;
      // this.sendParameterToiOS();

      this.sendMessage();
    }

  },

  async mounted(){

    // const t = this.$t;
    // console.log(`t is: ${this.$t('menu.home')}`);
    // console.log(`t is: ${t('menu.home')}`);

    // console.log(`in app mounted`);

    // await this.$auth.logout();

    // return;

    // await this.pwaSubscribe();

    //push #1
    // this.registerPwaPushNotificationsInit();
    //#push #2

    // this.isAuthenticated = this.$auth.isAuthenticated();
    // componentsHelpers.toastIt(this.$toasted, "Welcome  to Pnadi", 2, 'outline', true);

    // console.log(`in mounted`);

    // console.log(`process.env.NODE_ENV: ${process.env.NODE_ENV}`);

      // window.actions.myPostMessage = this.postMessage;

    // alert(`mounted, navigator.userAgent: ${navigator.userAgent}`);

    //   this.sendMessage();

    // if(this.isIos()){

    //   // alert(`user agent: ${navigator.userAgent}`);

    //   console.log(`isAuthenticated: ${this.isAuthenticated}`);
    //   this.hideTopBar = true;

    //   // this.sendParameterToiOS();

    //   this.sendMessage();
    // }
    //  this.testingCordova();

    if(localStorage.hasOwnProperty('pickedLayout')){

        let pickedLayout = localStorage.getItem('pickedLayout');

        // console.log(`typeof pickedLayout: ${typeof pickedLayout}`);

        if(pickedLayout == '0'){

          this.$layoutType = 0;

          this.isPinkStyle = true;

        }else if(pickedLayout == '1'){

          this.$layoutType = 1;

          this.isPinkStyle = true;
        }else if(pickedLayout == '2'){

          this.$layoutType = 2;

          this.isPinkStyle = true;

          // this.isPinkStyle = false;
        }

        else if(pickedLayout == '3'){

          this.$layoutType = 3;

          this.isPinkStyle = true;

          // this.isPinkStyle = false;
        }

          this.layoutType = this.$layoutType; 

          // console.log(`this.layoutType: ${this.layoutType}`);
        this.getCountry();
        
        // if(await this.$auth.isAuthenticated()){

        //   // console.log(`isAuthenticated: ${await this.$auth.isAuthenticated()}`);

        //   this.switchLayout(Number(pickedLayout));
        // }
    }
  },

  methods: {

    isColorfulLayoutType(){

        // console.log(`in isColorfulLayoutType`);

      return false;
      if(this.businessView){

        return true;
      }

      if(localStorage.hasOwnProperty('myStyle')){

        const style = localStorage.getItem('myStyle');

        if(style == 'pink'){

          // console.log(`return true`)

          return true;
        }else{

          // console.log(`return false`)
          return false;
        }
      }

      if(process.env.NODE_ENV === 'development'){

        return false;

      }else{

        return true;
      }

      return false;
      // return false;
      if(this.isPinkStyle){
      // console.log(`isPinkStyle: ${this.isPinkStyle}`);

        return false;
      }

      // if(process.env.NODE_ENV === 'development'){

      //   return false;
      // }
      // return process.env.NODE_ENV === 'development';
    },

    changeBusinessView(){

      this.businessView = !this.businessView;
      // console.log(`changeBusinessView`)
      this.setBusinessView();
    },

    checkUserSubPermission(){

      if(localStorage.hasOwnProperty(`permissionResult`)){

        return;
      }else{

        if (window.Notification && Notification.permission === 'granted') {
        
          // console.log(`aready granted`);
          localStorage.setItem('permissionResult', true);
        }
        else if (window.Notification && Notification.permission !== 'denied') {
          
          Notification.requestPermission(status => {
            if (status === 'granted') {
              
            localStorage.setItem('permissionResult', true);
            } else {
              
              localStorage.setItem('permissionResult', false);
            }
          });
        } else {

          localStorage.setItem('permissionResult', false);
        }
      }
    },  

    async subscribe(registration) {
    // First get a public key from our Express server

    // console.log(`in fetch('pnadiapi/subscribing)`);

    // const response = await fetch('pnadiapi/subscribing/vapid-public-key');

  //  const response=  await axios({method: 'post',url: '/pnadiapi/subscribing/subscribe'});
   
    // const response = await axios.get('pnadiapi/subscribing/vapid-public-key')

    // console.log(`vapid-public-key: ${JSON.stringify(response)}`);

    const body = await response.json();
    const publicKey = body.publicKey;
  
    // this is an annoying part of the process we have to turn our public key
    // into a Uint8Array
    const Uint8ArrayPublicKey = urlBase64ToUint8Array(publicKey);
  
    // registering a new subscription to our service worker's Push manager
    const subscription = await registration.pushManager.subscribe({
      // don't worry about the userVisible only atm
      userVisibleOnly: true,
      applicationServerKey: Uint8ArrayPublicKey
    });
  
    // Sending the subscription object to our Express server
    await fetch('pnadiapi/subscribing/subscribe',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subscription.toJSON())
      }
    );
    // console.log('Subscribed')

    return subscription;
  },

    //push notification tutorial #2 start
   async initializeApp() {
      
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        // console.log('Service Worker and Push is supported');

        this.registerPwaPushNotificationsInit()

      } else {
        console.warn('Push messaging is not supported');
        notificationButton.textContent = 'Push Not Supported';
      }
    },

     initializeUi() {
      
      notificationButton.addEventListener('click', () => {
        //Do something here
        this.displayNotification();
      });
    },

     displayNotification() {
      //Ask user if we show notifications
      if (window.Notification && Notification.permission === 'granted') {
        
        this.notification();
      }
      // If the user hasn't told whether he wants to be notified or not
      // Note: because of Chrome, we cannot be sure the permission property
      // is set, therefore it's unsafe to check for the "default" value.
      else if (window.Notification && Notification.permission !== 'denied') {
        Notification.requestPermission(status => {
          if (status === 'granted') {
            
            this.notification();
          } else {
            
            // alert('You denied or dismissed permissions to notifications.');
          }
        });
      } else {
        // If the user refuses to get notified
        // alert(
        //   'You denied permissions to notifications. Please go to your browser or phone setting to allow notifications.'
        // );
      }
    },

    notification() {
      
      const options = {
        body: 'Testing Our Notification',
        icon: './bell.png'
      };
      swRegistration.showNotification('PWA Notification!', options);
    },

    //push notification tutorial #2 end

    //push notification tutorial #1 start
     registerPwaPushNotificationsInit(){
      
      if (this.isIos()){

        return;
      }

      const pwaSubscribe = this.pwaSubscribe;

      navigator.serviceWorker.ready.then(reg => {

        reg.pushManager.getSubscription().then(async (sub) => {

          if( typeof sub == 'undefined' || JSON.stringify(sub) == '{}' || sub == null){

              // console.log(`in undefined`);

            pwaSubscribe();
            // ask to register
          }else{

            // sub.unsubscribe()
            // this.insertUserPushMutate(sub);
          }
        })
      });

      // navigator.serviceWorker.getRegistration().then(reg => {

      //   reg.pushManager.subscribe({

      //     userVisibleOnly: true,

      //   }).then(sub => {

      //       console.log(`sub#2: ${JSON.stringify(sub)}`);
      //   })
      // })
    },

    async pwaSubscribe(){

      let sw = await navigator.serviceWorker.ready;

      let push = await sw.pushManager.subscribe({
        
        userVisibleOnly: true,
        applicationServerKey: process.env.VUE_APP_PWA_MY_PUSH_PUBLIC,
      })

      this.insertUserPushMutate(push);
    },

    async insertUserPushMutate(push){

      // console.log(`push: ${JSON.stringify(push)}`)

      const object = JSON.stringify(push);

      // console.log(`push object : ${object}`);

      // console.log(`keys: ${Object.keys(push)}`)

      // console.log(`endpoint: ${JSON.stringify(push.endpoint)}`)
      // console.log(`push.expirationTime: ${JSON.stringify(push.expirationTime)}`)

      // console.log(`push.keys: ${JSON.stringify(push.keys)}`)

      // console.log(`p256dh: ${JSON.stringify(push.p256dh)}`)
      // console.log(`keys[0].p256dh: ${JSON.stringify(push.keys[0].p256dh)}`)  

      try{

        let result = await this.$apollo.mutate({

          mutation: myThreeInserts.user_push_insert_only_endpoint,
          // mutation: myThreeInserts.user_push_insert,

          variables: {

            userId: this.$userId,
            endPoint: push.endpoint,
            object: object
          },

          // variables: {

          //   userId: this.$userId,
          //   endPoint: push.endpoint,
          //   p256dh: push.keys.p256dh,
          //   auth: push.keys.auth
          // },
              
          error(error){

            this.mutationError = error;
            // console.log(`error: ${error}`);
            // componentsHelpers.sendError(this.$apollo, this.$userId, 'App', ',main', 'insertUserPushMutate - 1' , error);
          }
        });
      }catch(error){
            console.log(`error: ${error}`);

        // componentsHelpers.sendError(this.$apollo, this.$userId, 'App', ',main', 'insertUserPushMutate - 2' , error);

        // componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
      }
    },
    //push notification tutorial #1 end


    //to only show profile
    hideBars(){

      //1- make it true
      
      return parameters.showFakeMobile;
      // return false;
      // return true;

    },

    isIos(){

      // console.log(`isiOS: ${navigator.userAgent == 'Safari/602.1 ios-pnadi'}`);

      // return false;
      // return true;
      return navigator.userAgent == 'Safari/602.1 ios-pnadi';
    },



      // async clientTrimDevices(devices){

      //   // console.log(`devices: ${JSON.stringify(devices)}`)

      //   // console.log(`devices[5]: ${JSON.stringify(devices[4])}`)

      //   const apollo = this.$apollo;

      //   const toasted = this.$toasted;

      //   try{

      //     if(devices.length > 3){
            
      //       for(let i = devices.length - 1; i > 2; i--){

      //       // console.log(`triming device-id: ${devices[i].id}`);

      //         const deviceId = parseInt(devices[i].id);

      //         // const deviceId = devices[i].device_id;

      //         console.log(`fcmToken: ${deviceId}`);

      //         // console.log(`triming device-id: ${deviceId}`);

      //         // console.log(`typeof triming device-id: ${typeof deviceId}`);

      //         await this.$apollo.query({
          
      //           query: myDeletes.delete_device,

      //          variables: {
              
      //               deviceId: deviceId
      //           },   
      //           error(error){
                  
      //             this.allLoaded = false;

      //             componentsHelpers.sendError(apollo, this.$userId, 'App', ',main', 'clientTrimDevices' , error);
                      
      //             componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                  
      //             this.tokenError = JSON.stringify(error);
      //           },   
      //         });
      //       }
      //     }
      //   }catch(error){

      //     // console.log(`error: ${error}`)
      //     componentsHelpers.sendError(apollo, this.$userId,'App', ',main', 'clientTrimDevices' , error);
                      
      //     componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
      //   }
      // },

      async serverTrimDevices(userId){

        try{
            let result = await axios({method: 'post',url: '/pnadiapi/devices/deleteDevices',
                data: {
                
                key: this.storedKey,
                userId: userId,
                // devices: devices,
                }});

        // console.log(`result is ${JSON.stringify(result)}`);

            if(result.status == 200){

              //to do
              return;
            }

        }catch(error){

          componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimDevices' , error);
                      
          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
        }
      },

      async serverTrimPushSubscriptions(pushSubscriptions){

        try{

          for(let i = 3; i <  pushSubscriptions; i++){

              const DeleteSlotResult = await this.$apollo.mutate({
              
                mutation:  myThreeDeletes.user_push_subscription_delete,

                variables: {

                    id: pushSubscriptions[i].id
                },
                    
                error(error){

                  this.showLoader = false;
                  this.mutationError = error;
                  componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimPushSubscriptions - 1' , error);
                }
              });
          }

        }catch(error){

          componentsHelpers.sendError(this.$apollo, this.$userId,'App', ',main', 'serverTrimPushSubscriptions - 2' , error);

          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
        }
      },

     async sendUserInfoMessage(user){
        
        // console.log(`sendUserInfoMessage`);

        let myKey =  await authHttpHelper.getToken(localStorage.getItem('for_pnadi'))
        // console.log(`res: ${JSON.stringify(myKey.data)}`);
        // alert(`before sendUserInfoMessage`);
        // let myKey = this.$auth.getKey();
        //swift submission #1
        let userObject = {
          user,
          key: myKey.data
        }
        
        if(typeof window.webkit != 'undefined'){

              // alert(`userObject: ${JSON.stringify(userObject)}`);

            window.webkit.messageHandlers.userInfo.postMessage(userObject);
        }else{

          // console.log(`userObject: ${JSON.stringify(userObject)}`);
        }                  
        // alert(`before sendUserInfoMessage`);
    },

     sendMessage() {
       
        // alert(`before, message sent`);

       //change parameter2
      //swift submission #2

      // console.log(`typeof window.webkit: ${typeof window.webkit}`)

          // console.log(`post authenticated: ${this.isAuthenticated}`);

        if(typeof window.webkit != 'undefined'){
          
          // alert(`post authenticated: ${this.isAuthenticated}`);
          if(this.isAuthenticated){

            //6- change  value 1
            // window.webkit.messageHandlers.mainMessage.postMessage({parameter1 : "value1", parameter2 : "value2"})
            window.webkit.messageHandlers.mainMessage.postMessage({parameter1 : "notvalue1", parameter2 : "value2"})
          }
        }
        // alert(`after, message sent`);
    },


     sendJSON() {

              //  alert(`before sendJSON, message sent`);

        var dictionary = {"key1" : "value1&value1b", "key2" : [{"key3" : "€", "key4" : "menù", "key5" : "a?b"}]};
        window.webkit.messageHandlers.jsonMessage.postMessage({message : dictionary});

                // alert(`after sendJSON, message sent`);
    },

  
  postMessage(){

    alert(`in post message from action`);
  },

    testingCordova(){
    
    (function(window, open) {
                  window.open = function(url) {
                  open.call(window, url, '_self', "width=100, height=100, menubar=yes");
                  };
              })(window, window.open);

      if(window.hasOwnProperty("cordova")){
        
        console.log("You're on a mobile device");
        alert(`window.hasOwnProperty("cordova")`);
      }

      // Or 

      else if(typeof(cordova) == "object"){
          
          console.log("You're on a mobile device");
          alert(`typeof(cordova) == "object"`)
      }

      // Or 

      else if(!!window.cordova){

          console.log("!!window.cordova");
          alert(`window.cordova"`)
      }
      else{
            
            // alert(`in web`);
            // alert(`navigator.userAgent: ${navigator.userAgent}`);
            
            // console.log(`navigator.userAgent: ${JSON.stringify(navigator.userAgent)}`);

            if(JSON.stringify(navigator.userAgent).includes('Safari/602.1 Google')){

                // alert(`navigator.userAgent: safari/602.1 Google`);

                (function(window, open) {
                  window.open = function(url) {
                  open.call(window, url, '_', "width=100, height=100, menubar=yes");
                  };
              })(window, window.open);


                  // window.open = cordova.InAppBrowser.open;
            }
            //else if(JSON.stringify(navigator.userAgent).includes('Mozilla/5.0')){

            //     alert(`navigator.userAgent: mozarilla`);

            //       // window.open = cordova.InAppBrowser.open;

            // }else if(JSON.stringify(navigator.userAgent).includes('Safari')){

            //     alert(`navigator.userAgent: only safari`);

            //       // window.open = cordova.InAppBrowser.open;

            // }
      }

      // document.addEventListener("deviceready", this.onDeviceReady, false);

      // alert(`in created`);
      
      // if(!!window.cordova){

        // if(cordova){

        //   console.log(`just cordova: ${cordova}`);
        // }

        // console.log(`just cordova: ${cordova}`);

      //   if(window.cordova){

      //   const cordovaTest = window.cordova;

      //   console.log(`1st cordova is: ${cordova}`);
      //   alert(`1st cordova is: ${cordova}`);

      //   // if(!!device){
      //   if(device){

      //     // if(!!device.platform){
      //     if(device.platform){

      //       console.log(`1st device.platform is: ${device.platform}`);
      //       alert(`1st device.platform is: ${cordova}`);
      //     }
      //   }
      // }
    },

     onDeviceReady() {
      
      // alert(`device ready`);
      // console.log(device.cordova);
      // alert(`device.cordova: ${device.cordova}`);
    },

    cancelBrandHover(event){

        this.brandHover = false;

        },

    async setUserId(){

      if(await this.$auth.isAuthenticated() || this.isAuthenticated){

        const apollo = this.$apollo;

        const toasted = this.$toasted;

        let userResult = await this.$apollo.query({
          
          query: myQueries.my_user_query,
          
          error(error){
            
            this.allLoaded = false;

            componentsHelpers.sendError(apollo, userId,'App', ',main', 'loadAllInfo - 2' , error);
                
            componentsHelpers.toastIt(toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            
            this.tokenError = JSON.stringify(error);
          },   
        });

        if(userResult.data.user.length > 0){
            
          this.$userId = userResult.data.user[0].id;
        }
        else{

          this.$userId = 0;
        }

        console.log(`this.$userId: ${JSON.stringify(this.$userId)}`);
      }
    },
    
    async getCountry(){

      // console.log(`in get country`);
      try{

        // if (navigator.geolocation) {

        //   navigator.geolocation.getCurrentPosition(this.getPosition);
        // }

      // console.log(`has property :${localStorage.hasOwnProperty('countryCode')}`);

      // let result = await otherServices.getCountryCode();

      //   console.log(result);

        if(!localStorage.hasOwnProperty('countryCode')){

          // let result = await axios({method: 'get',url: `https://freegeoip.app/json/`})

          // console.log(`ip result:`);

          let countryCode = await otherServices.getCountryCode();

          // console.log(`countrycode:`);

          // console.log(result.data);
          // console.log(`country: ${result.data.country_name}`);
          // console.log(`countryCode: ${result.data.country_code}`);

          localStorage.setItem('countryCode', countryCode);

          this.$countryCode = countryCode;
        }
      else{
        
        this.$countryCode = localStorage.getItem('countryCode');

        // console.log(`JSON.stringify(this.$countryCode): ${JSON.stringify(this.$countryCode)}`);

        if(JSON.stringify(this.$countryCode) == 'undefined' || JSON.stringify(this.$countryCode) == '"undefined"' || typeof this.$countryCode == undefined){


          // console.log(`country code is undefined`);

          let countryCode = await otherServices.getCountryCode();

          // console.log(`countryCode: ${countryCode}`)

          localStorage.setItem('countryCode', countryCode);

          this.$countryCode = countryCode;

        }else{

          // console.log(`country code is defined`);

          // console.log(`stored countrycode:`);

          // console.log(this.$countryCode);
        }

        // console.log(`stored countrycode:`);

        // console.log(this.$countryCode);
      }

      // console.log(`this.$countryCode : ${this.$countryCode}`);

      // console.log(`this.$countryCode equal == 'GB' : ${this.$countryCode == 'GB'}`);

      }catch(error){

          componentsHelpers.sendError(this.$apollo, 0,'App', 'Main', 'getCountry', error);

          // componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true)
      }
    },

      getPosition(position) {

          // console.log(`Position, latitude: ${position.coords.latitude}, longitutde: ${position.coords.longitude}`);
        },

    preparePromptMessage(){

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      // Update UI to notify the user they can add to home screen
      addBtn.style.display = 'block';

      addBtn.addEventListener('click', (e) => {
        // hide our user interface that shows our A2HS button
        addBtn.style.display = 'none';
        // Show the prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt = null;
          });
      });
    });


    // const stashInstallPrompt = this.stashEventPrompt;

    //   if ( "onbeforeinstallprompt" in window ) {

      
    //   window.addEventListener( "beforeinstallprompt", stashInstallPrompt );

    //   console.log(' in onbeforeinstallprompt');

    //   }
    },
    
    stashEventPrompt(event){

      // console.log(' in stashEventPrompt');

        event.preventDefault();

        this.beforeInstallPrompt = event;

        // console.log(`Catched InstallPrompt`);

        this.beforeInstallPrompt.prompt()
        .then( function ( evt ) {

        // console.log(' in beforeInstallPrompt.prompt');

            return beforeInstallPrompt.userChoice;

        } )
        .then( function ( choiceResult ) {

            //do stuff here
            console.log(`InstallPrompt was successful`);

        } )
        .catch( function ( err ) {

            if ( err.message.indexOf( "user gesture" ) > -1 ) {
              //recycle, but make sure there is a user gesture involved

                console.log(`ERROR: user gesture > -1`);

            } else if ( err.message.indexOf( "The app is already installed" ) > -1 ) {

                console.log(`ERROR: The app is already installed`);

              //the app is installed, no need to prompt, but you may need to log or update state values
            } else {
              return err;
            }
        });
    },

    async switchLayout(val){

        // console  .log(`in v1 switch layout with val:${val}`)

        // console.log(`router name:${await this.$auth.isAuthenticated()}`)

        // console.log(`switchLayout val: ${val}`);
          
          if(val != 0 && !(await this.$auth.isAuthenticated())){

            // console.log(`in toastIt with: ${this.$t('home.pleasLogin')}`);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.pleasLogin'), 1, 'outline', true);

            return;
          }

          if(this.$layoutType == val){

            // console.log(`in return`);
            return;
          }

            // this.layoutTypePopOverShow = false;

          if(this.businessView){

            // if(val == 3){

            //     this.$layoutType = val; 

            //     localStorage.setItem('pickedLayout', val);
                
            //     if(localStorage.hasOwnProperty('businessLayout4')){
                  
            //       this.$router.push(localStorage.getItem('businessLayout4'));

            //       // console.log(`businessLayout4: ${localStorage.getItem('businessLayout4')}`);
            //     }
            //     else{

            //       localStorage.setItem('businessLayout4', 'businessMemberships');

            //       this.$router.push('businessMemberships')
            //     }
            // }
            
            // else if(val == 2){
            if(val == 2){
                // componentsHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);

                // return;

                this.$layoutType = val; 

                localStorage.setItem('pickedLayout', val);
                
                if(localStorage.hasOwnProperty('businessLayout3')){
                  
                    this.$router.push(localStorage.getItem('businessLayout3'));
                }
                else{

                  localStorage.setItem('businessLayout3', 'pitch');

                  // this.$router.push('bookingpitchPitches')
                  this.$router.push('pitch')

                }
            }
            else if(val == 1){

                this.$layoutType = val;

                localStorage.setItem('pickedLayout', val);
                
                if(localStorage.hasOwnProperty('businessLayout2')){
                  
                    this.$router.push(localStorage.getItem('businessLayout2'));
                }
                else{

                  localStorage.setItem('businessLayout2', 'classes');

                  this.$router.push('classes')
                }
            }
            else{

                this.$layoutType = val;

                if(localStorage.hasOwnProperty('businessLayout1')){
                  
                    this.$router.push(localStorage.getItem('businessLayout1'));
                }
                else{

                  localStorage.setItem('businessLayout2', 'home');

                  this.$router.push('home');
                }

                localStorage.setItem('pickedLayout', val);
            }
          }else{

            // console.log(`not business`);
            //to do
            // if(val == 3){

            // }

            // else if(val == 2){
            if(val == 2){
                // componentsHelpers.toastIt(this.$toasted, this.$t('home.comingSoonToast'), 1, 'outline', true);

                // return;

                this.$layoutType = val;

                // console.log(`val: ${val}`);

                localStorage.setItem('pickedLayout', val);
                
                if(localStorage.hasOwnProperty('clientLayout3')){

                    console.log(`clientLayout3: ${localStorage.getItem('clientLayout3')}`)
                    this.$router.push(localStorage.getItem('clientLayout3'));
                }
                else{

                  localStorage.setItem('clientLayout3', 'bookingPitches');

                  this.$router.push('bookingPitches')
                }
            }
            else if(val == 1){

                this.$layoutType = val;

                // console.log(`val: ${val}`);

                localStorage.setItem('pickedLayout', val);
                
                if(localStorage.hasOwnProperty('clientLayout2')){
                  
                    console.log(`clientLayout2: ${localStorage.getItem('clientLayout2')}`)

                    this.$router.push(localStorage.getItem('clientLayout2'));
                }
                else{

                  localStorage.setItem('clientLayout2', 'sessions');

                  this.$router.push('sessions')
                }
            }
            else{

                // console.log(`val: ${val}`);
                
                this.$layoutType = val;

                if(localStorage.hasOwnProperty('clientLayout1')){
                  
                    this.$router.push(localStorage.getItem('clientLayout1'));
                }
                else{

                  localStorage.setItem('clientLayout1', 'home');

                  this.$router.push('home');
                }

                localStorage.setItem('pickedLayout', val);
            }
          } 
        },

    brandIsHovered(val){
      

      this.brandHover = val;

      // if(val){

      //   new createPopper(this.$refs.menuDropdownRef, this.$refs.DropdownRef, {
      //   placement: "bottom"
      //   });
      // }else{

      // }
    },

    goBack(){

      // this.backMixin_handleBack();

      if(this.$route.name !=  'home')
      {
        this.$router.go(-1);
      }
    },
    
    reloadApp(){

      this.showLoader = true;

      location.reload();
    
        // location.reload(true);

    },


    goToInstagram(){

            // For now go Home
            // this.$router.replace({ path: '/home', query: { redirected: 'false' }});
      },
    resetApp(){

      localStorage.clear();

      location.reload(true);
    },

      async checkingAuthentication(){


        let result = await this.$auth.isAuthenticated();
        

        // console.log(`authentication result: ${result}`);
        this.isAuthenticated = result;

        // localStorage.setItem('for-pnadi', "4901ce33a8b92b9c4c1f4a7a34cd44859cc80232bbd71aafbda42d52a55e85fb5x4icfYdTbPGgTkCZ5EZCWikOp8Jh20FEEJLnBns8PA=");
        // console.log(`in checking authentication`);

        // console.log(`Created, inside app.vue component and authentication is ${result}`);

      },
      setBusinessView(){

          // console.log(`setting businessView: ${this.businessView}` )
          localStorage.setItem('businessView', this.businessView);
          
          if(this.businessView){

            if(!localStorage.hasOwnProperty('businessLayout1')){

              localStorage.setItem('businessLayout1', 'home')
            }

            // const goTo = localStorage.getItem('businessLayout1');
            
            // if(this.$route.name != goTo){

            //   this.$layoutType = 0;
            //   this.$router.push(goTo)

            // }else{

            // }
          }else{

            if(!localStorage.hasOwnProperty('clientLayout1')){

              localStorage.setItem('clientLayout1', 'home')
            }

            // const goTo = localStorage.getItem('clientLayout1');
            
            // if(this.$route.name != goTo){

            //   this.$layoutType = 0;
            //   this.$router.push(goTo);
            // }
          }
          
          // console.log(`before replace`);
          this.$router.replace({ path: '/' })

          // location.reload();
      },

  },

  apollo:{

    user: {
            query:function(){

              // if(this.isAuthenticated && this.userInfoError == ''){
                return myQueries.ios_token_user_query;
              // }
            },
             
            variables: {
              
            },

            async update(data){

              // console.log(`user: ${JSON.stringify(data)}`);

              // console.log(`user: ${JSON.stringify(data.user[0].user_devices.length)}`);


              // await this.clientTrimDevices(devices);


              if(JSON.stringify(data) !='{}' && data.token[0].user!= null){
                
                // this.$store.dispatch('updateUserId', this.$userId)

                this.$userId = data.token[0].user.id;

                // this.$store.commit('updateUserId', this.$userId)
                let devices = data.token[0].user.user_devices;
                let pushSubscriptions = data.token[0].user.user_push_subscriptions;

                this.checkUserSubPermission();

                if (devices.length > 3){

                  await this.serverTrimDevices(data.token[0].user.id);
                }

                if (pushSubscriptions.length > 3){

                  await this.serverTrimPushSubscriptions(pushSubscriptions);
                }

                if(data.token.length > 0){

                  if(data.token[0].user.is_client == true && data.token[0].user.is_business == true){

                this.userType = 3;

              }
              else if(data.token[0].user.is_client == true){

                this.userType = 1;

                // console.log(`user.is_client: ${data.token[0].user.is_client}`)
                this.businessView = false;
                this.setBusinessView();

              }else if(data.token[0].user.is_business == true){

                // console.log(`user.is_business: ${data.token[0].user.is_business}`)

                this.userType = 2;
                this.businessView = true;
                 this.setBusinessView();
              }

              if(data.token[0].user.is_broker == true){

                this.isUserBroker =  true;
              }

            if(this.isIos()){
                
                // this.sendUserInfoMessage(data.user[0]);

                this.sendUserInfoMessage(data.token[0].user);
              }else{

                  // this.sendUserInfoMessage(data.user[0]);
              }


              this.initializeApp();

              this.$userId = data.token[0].user.id;

              return data.user;
                }
              }else{
                
                // console.log(`router name: ${this.$route.name}`);

                this.$store.commit('appIsLoaded', true);

                if(this.$route.name != 'profile'){


                  this.$router.push('profile');
                }
              }
            },

            error(error){
                
                this.userInfoError = JSON.stringify(error);
            },

            skip() {
              
            return !this.isAuthenticated;
          },
        },
  },


  data:function (){

    return {
        
        // testDictionary: {"key1" : "value1&value1b", "key2" : [{"key3" : "€", "key4" : "menù", "key5" : "a?b"}]},
        // urlPrefix: "nativeapp://",
        swRegistration: null,
        second_slot: [],
        hideTopBar: false,
        isMainTheme: true,
        isEnglish: true,
        homeHover: false,
        brandHover: false,
        brandHover2: false,
        beforeInstallPrompt: null,
        showLoader: false,

        // businessHover: false,
        isAuthenticated: false,
          
        //  businessView: {

        //     get: function() {
              
        //       let businessView = localStorage.getItem('businessView')? localStorage.getItem('businessView'): false;
        //                       console.log(`get businessView of ${businessView}`)

        //       return businessView
        //     },
        //     set: function(businessView) {
        //       console.log(`set businessView to ${businessView}`)
        //       localStorage.setItem('businessView', businessView)
        //     }
        //   },
        businessView: false,
        // adminView: false,

        switchMenu: false,

        isPinkStyle: true,

        layoutType: 0,

        displayedSection: 0,
        user: [],
        userInfoError: '',
        userType: 1,
        isUserBroker: false,
        appIsLoaded: true,
        isFirstLaunch: false

        
    }
  },

   watch: {

        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;
 
            // console.log(`pinkStyle: ${this.isPinkStyle}`);

            // console.log(`in Watcehr: pink is ${newValue}`);
            // /    require('tailwindcss-rtl'),

            },

            '$route.name'(newValue) {
            
            // this.isPinkStyle = newValue;

            // console.log(`in Watch: route.name is ${newValue}`);
            // /    require('tailwindcss-rtl'),

            },

            '$layoutType'(newValue) {
              
              if(newValue == 0){

                this.isPinkStyle = true;

              }else if(newValue == 1){

                this.isPinkStyle = true;

              }else if(newValue == 2){

                this.isPinkStyle = true;

                // this.isPinkStyle = false;
              }else{

                this.isPinkStyle = true;
              }

              this.layoutType = newValue;

              // console.log(`layoutType: ${this.layoutType}`);

            },
            
        },
        
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color:magenta;
  background: #63B3ED;
}

.mainLink{

  color:magenta;
  background: #63B3ED;
}

.add-button {
  position: absolute;
  top: 1px;
  left: 1px;
}

body {
 padding: env(safe-area-inset-top) 
 env(safe-area-inset-right)
  env(safe-area-inset-bottom)
     env(safe-area-inset-left);
}
</style>
